import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export const Guarantee = () => {
  return <section className="py-20 bg-beige/20" data-id="element-95">
      <div className="max-w-3xl mx-auto px-6" data-id="element-96">
        <FadeIn className="bg-white rounded-3xl p-8 md:p-12 border border-gold-soft/30 shadow-soft text-center relative overflow-hidden" data-id="element-97">
          <div className="absolute inset-0 bg-gradient-to-br from-gold-light/10 to-transparent pointer-events-none" data-id="element-98" />

          <div className="relative z-10" data-id="element-99">
            <div className="w-20 h-20 mx-auto bg-gold-soft/20 rounded-full flex items-center justify-center mb-6 border-2 border-gold-soft/40" data-id="element-100">
              <ShieldCheck className="w-10 h-10 text-gold-soft" data-id="element-101" />
            </div>

            <span className="inline-block text-xs font-bold tracking-widest uppercase text-gold-soft mb-3" data-id="element-102">
              Garantía 7 días
            </span>

            <h2 className="text-3xl md:text-4xl mb-6 font-serif" data-id="element-103">
              Empezá <em data-id="element-104">sin miedo.</em>
            </h2>

            <div className="space-y-4 text-text-brown/80 max-w-xl mx-auto" data-id="element-105">
              <p className="text-lg leading-relaxed" data-id="element-106">
                Tenés <strong className="text-text-dark" data-id="element-107">7 días</strong> para
                probar el programa completo.
              </p>
              <p className="leading-relaxed" data-id="element-108">
                Si no es para vos, te devolvemos el{' '}
                <strong className="text-text-dark" data-id="element-109">100% de tu dinero.</strong>
              </p>
              <p className="text-sm italic" data-id="element-110">
                Sin preguntas. Sin trámites complicados.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};